import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, styled } from '@mui/material';

const StyledWrapper = styled('span')`
  position: relative;
  display: flex;
`;

const UiLoading = ({ children, spinning }) => {
  return (
    <StyledWrapper>
      {children}
      {spinning && (
        <CircularProgress
          size={24}
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: '-12px',
            marginLeft: '-12px',
          }}
          color='primary'
        />
      )}
    </StyledWrapper>
  );
};

UiLoading.propTypes = {
  children: PropTypes.node,
  spinning: PropTypes.bool,
};

export default UiLoading;
